<template>
  <div class="app">
    <div class="logo">
      <div class="but">
        <img src="../assets/logo10@2x.jpg" class="logo_img">
        <h3 class="logoText">薪福荟选</h3>
      </div>
    </div>
    <div class="body">
      <div class="header">
        <h3 class="text">薪福荟选店铺入驻信息</h3>
      </div>
      <div class="main">
        <!--      审核进度-->
        <div class="schedule" v-show="schedule_active">
          <div style="text-align: center;margin-bottom: 5px;">
            <el-image
              style="width: 70px; height: 70px"
              :src="require(`../assets/state/${state_image}.png`)"
              fit="fill"></el-image>
            <div>
              <strong style="font-size: 18px">{{
                  schedule_active === 2 ? '审核中' : schedule_active === 3 ? '审核通过' : '审核拒绝'
                }}</strong>
            </div>
          </div>
          <el-steps :active="schedule_active" align-center>
            <el-step icon="el-icon-success" title="入驻申请" :description="getTime(createTime)"></el-step>
            <el-step icon="el-icon-success" title="审核中"></el-step>
            <el-step icon="el-icon-success" title="审核结果" :description="getTime(auditTime)"></el-step>
          </el-steps>
          <div class="account" v-show="jujue_shuoming !== ''">
            <strong>审核说明：</strong><span>{{ jujue_shuoming }}</span>
          </div>
          <!--          分割线-->
          <el-divider style="background:#F3F3F3"/>
        </div>
        <div class="shop">店铺基本信息</div>
        <el-form ref="form" :model="form" label-width="140px" label-position="left" :rules="rules" class="form">
          <el-form-item label="店铺LOGO:" class="form_logo store_logo">
            <div class="but1">
              <el-upload
                action="https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadImg"
                :limit="1"
                :class="{uploadLogo: true, uploadLogoClass: uploadSwitch1}"
                :before-upload="beforeAvatarUpload"
                :on-success="uploadseccess"
                list-type="picture-card"
                accept=".png,.jpg,.jpeg,.gif"
                :file-list="form.logoImg"
                :on-remove="handleRemove">
                <img class="logo_img" src="../assets/Group 1528@2x.png" v-if="!form.dialogImageUrl">
              </el-upload>
              <span class="logo_text">建议尺寸200*200像素</span>
            </div>
          </el-form-item>
          <el-form-item label="店铺名称:" class="form_name store_name" prop="name">
            <el-input v-model="form.name" placeholder="请输入店铺名称" maxlength="20" clearable/>
            <span class="logo_text">店铺名称建议20字符以内，超出在店铺页可能展示不全</span>
          </el-form-item>
          <el-form-item label="店铺简介:" class="form_intro" prop="intro">
            <el-input v-model="form.intro" type="textarea" :rows="3" placeholder="请输入店铺简介" maxlength="100"
                      show-word-limit clearable></el-input>
          </el-form-item>
          <el-form-item label="店铺所在地区:" class="form_area" prop="region">
            <el-cascader
              v-model="form.region"
              size="large"
              :options="options_as"
              class="formItemCascader"
              @change="handleChange"
              placeholder="请选择店铺所在地"
              clearable
            />
            <!--              @blur="store_address"-->
          </el-form-item>
          <el-form-item label="店铺备注:" class="form_backup">
            <el-input v-model="form.backup" type="textarea" :rows="3" placeholder="请输入备注" maxlength="100"
                      show-word-limit clearable></el-input>
          </el-form-item>
          <!--          分割线-->
          <el-divider/>
          <div class="shop shop1">店铺联系信息</div>
          <el-form-item label="店铺管理员昵称:" prop="posAdmin">
            <el-input v-model="form.posAdmin" placeholder="请输入店铺管理员昵称" clearable />
          </el-form-item>
          <el-form-item label="店铺联系电话:" class="form_name profit store_information" prop="shop_contact_number">
            <el-input v-model="form.shop_contact_number" :disabled="true" placeholder="请输入店铺联系电话" clearable/>
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              content="联系电话会作为审核成功短信通知、账号登录的依据。">
              <el-button slot="reference" class="reference reference2"><img src="../assets/Vector@2x.png" alt=""
                                                                            class="form_name_img"/></el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label="店铺联系地址:" class="form_name store_address" prop="shop_contact_address">
            <el-input v-model="form.shop_contact_address" placeholder="请输入店铺联系地址" clearable maxlength="20"
                      show-word-limit/>
          </el-form-item>
          <!--          分割线-->
          <el-divider/>
          <div class="shop shop1">店铺证照信息</div>
          <el-form-item label="上传执照照片:" class="form_logo form_backup uploadSeccess">
            <el-upload
              action="https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadBusLicenseImg"
              :limit="1"
              :class="{uploadLogo: true, uploadLogoClass: uploadSwitch2}"
              :before-upload="beforeAvatarUpload"
              :on-success="uploadseccess2"
              list-type="picture-card"
              accept=".png,.jpg,.jpeg,.gif"
              :file-list="form.license"
              :on-remove="handleRemove2">
              <img class="logo_img" src="../assets/Group 1528@2x.png" v-if="!form.dialogImageUrl2">
            </el-upload>
            <!-- <span class="logo_text">建议尺寸200*200像素</span> -->
          </el-form-item>
          <el-form-item label="其他资质图片:" class="form_logo form_backup">
            <el-upload
              action="https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadImg"
              :limit="1"
              :class="{uploadLogo: true, uploadLogoClass: uploadSwitch3}"
              :before-upload="beforeAvatarUpload"
              :on-success="uploadseccess3"
              list-type="picture-card"
              accept=".png,.jpg,.jpeg,.gif"
              :file-list="form.license2"
              :on-remove="handleRemove3">
              <img class="logo_img" src="../assets/Group 1528@2x.png" v-if="!form.dialogImageUrl3" alt="" />
            </el-upload>
            <!-- <span class="logo_text">建议尺寸200*200像素</span> -->
          </el-form-item>
          <el-form-item label="企业名称:" class="form_backup" prop="enterprise_name">
            <el-select  
              v-model="form.enterprise_name"
              filterable  
              remote  
              reserve-keyword  
              placeholder="请输入企业名称"
              @blur="selectBlur"
              @change="selectQiye"
              :remote-method="remoteMethod"  
              :loading="loading">
              <el-option  
                v-for="item in qiyeOptions"  
                :key="item.value"  
                :label="item.label"  
                :value="item.value">  
              </el-option>  
            </el-select> 
          </el-form-item>
          <el-form-item label="企业类型:" class="form_backup" prop="type_of_enterprise">
            <el-input v-model="form.type_of_enterprise" placeholder="请输入企业类型" maxlength="20" show-word-limit clearable/>
          </el-form-item>
          <el-form-item label="信用代码:" class="form_backup" prop="credit_code">
            <el-input v-model="form.credit_code" placeholder="请输入统一社会信用代码" clearable/>
          </el-form-item>
          <el-form-item label="注册省份:" class="form_backup" prop="domicile">
            <el-select v-model="form.domicile" placeholder="请选择注册省份">
              <el-option
                v-for="item in options_as"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执照法人:" class="form_backup" prop="licensed_legal_person">
            <el-input v-model="form.licensed_legal_person" placeholder="请输入执照法人" maxlength="20" show-word-limit
                      clearable/>
          </el-form-item>
          <el-form-item label="注册资金:" class="form_backup" prop="registered_capital">
            <el-input v-model="form.registered_capital" placeholder="请输入注册资金" maxlength="20" show-word-limit clearable/>
          </el-form-item>
          <el-form-item label="注册时间:" class="form_backup" prop="issueTime">
            <!-- <el-input v-model="form.issueTime" placeholder="请输入注册时间" maxlength="30" show-word-limit clearable/> -->
            <el-date-picker
              prop="issueTime"
              v-model="form.issueTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择注册时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="证照期限:" class="form_backup">
            <el-input v-model="form.term_of_operation" placeholder="请输入证照期限" maxlength="30" show-word-limit clearable/>
          </el-form-item>
          <el-form-item label="经营范围:" class="form_backup" prop="business_scope">
            <el-input v-model="form.business_scope" type="textarea" :rows="3" placeholder="请输入营业范围" maxlength="100"
                      show-word-limit clearable></el-input>
          </el-form-item>
          <!--          分割线-->
          <el-divider/>
          <div class="button_item" v-if="schedule_active !== 3">
            <el-button type="primary" @click="onSubmit('form')" class="create_button">{{ floot_bottom }}</el-button>
          </div>
          <div>  
        </div>  
        </el-form>
        <el-dialog
          :visible.sync="dialogVisible"
          width="25%"
          center
          class="dialog_prompt"
          :before-close="fenzuResetForm">
          <h2>{{ success }}</h2>
          <p><img src="../assets/Vector.png" alt="" style="width: 50px; height: 50px;"></p>
          <h3>管理员审核通过会以短信通知您</h3>
        </el-dialog>
<!--          :custom-class="dialog_visible ? 'dialogVisible_state_log' : 'dialogVisible_out_log'"-->
<!--          title="薪福荟选店铺入驻信息"-->
        <el-dialog
          :visible.sync="dialogVisible_bos"
          class="dialogVisible_bos"
          width="30%"
          :show-close="false"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          center>
<!--          label-width="80px"-->
          <el-form
            ref="ruleForm"
            :rules="ruleF"
            :model="ruleForm"
            class="login-form"
            autocomplete="on"
            label-position="left">
            <div class="wrap">
<!--              label="手机号:"-->
              <div class="img_but">
                <img src="../assets/logo10@2x.jpg" class="logo_img" alt="" />
              </div>
              <div class="title_but">薪福荟选店铺入驻信息</div>
              <el-form-item class="phone">
                <el-input placeholder="请输入手机号" type="text" oninput="value=value.replace(/[^\d.]/g,'')" maxlength="11" v-model="ruleForm.phone" @input="checkPhone" class="input-with-select" />
                <i v-show="!ruleForm_phone" @click="clickPhone" class="iconfont icon-xiayibu"></i>
                <i v-show="ruleForm_phone && !icon_loading && !phone_state" class="iconfont icon-xiayibu" @click="phone_search" style="color: #494949"></i>
                <i v-show="ruleForm_phone && icon_loading" class="ips el-icon-loading"></i>
              </el-form-item>
<!--              label="验证码:"-->

              <el-form-item  class="yanzhengma" v-show="phone_state">
                <el-input v-model="ruleForm.yanzhengma" maxlength="6" placeholder="请输入验证码" clearable>
                  <el-button class="but_1" slot="append" v-show="countshow" type="primary"
                             @click="submityan('ruleForm')">发送验证码
                  </el-button>
                  <el-button class="but_2" slot="append" v-show="!countshow" disabled>{{ count }} s</el-button>
                </el-input>
              </el-form-item>
            </div>
          </el-form>

          <span slot="footer" class="dialog-footer" v-show="phone_state">
              <el-button style="background-color: #2082dd;border: #2082dd;" type="primary" @click="submitForm">下一步</el-button>
            </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {regionData, TextToCode, CodeToText} from 'element-china-area-data'
import axios from "axios";
import {getDate, isvalidPhone} from "../utils";

export default {
  name: 'PC',
  data() {
    return {
      headers: {
            'Content-type': 'multipart/form-data'
      },
      shop_phone: false, // 店铺联系电话 输入框的禁用状态
      state_image: 'zhong', // 审核状态的图片 {zhong,wan,ju}
      jujue_shuoming: '', // 审核拒绝的说明
      createTime: '', // 创建时间
      auditTime: '', // 审核时间
      schedule_active: 0, // 审核进度
      phone_state: false,
      success: '提交成功',
      floot_bottom: '提交',
      dialogVisible_bos: true,
      // dialogVisible_bos: false,
      dialog_visible: true,
      countshow: true,
      count: '',
      ruleForm: {
        phone: '',
        yanzhengma: '' // 验证码
      },
      uploadSwitch1: false,
      uploadSwitch2: false,
      uploadSwitch3: false,
      qiyeOptions:[], // 企业集合
      searchQuery: '', // 用户输入的搜索词   
      loading: false, // 是否正在加载的标识  
      searchTimeout: null, // 用于存储 setTimeout 的 ID 
      provinceOptions:[], // 省份集合
      form: {
        dialogImageUrl: '', // logo
        dialogImageUrl2: '', // 执照
        dialogImageUrl3: '', // 其他资质图片
        logoImg: [], // 店铺logo
        name: '', // 店铺名称
        intro: '', // 店铺简介
        region: [], // 店铺所在地区
        options: '', // 地区信息
        backup: '', // 店铺备注
        type: '1', // 是否开启团购功能
        profit: '25', // 团购商品利润
        noProfit: '15', // 非团购商品利润
        posAdmin: '', // 店铺管理员昵称
        shop_contact_number: '', // 店铺联系电话
        shop_contact_address: '', // 店铺联系地址
        license: [], // 执照照片
        license2: [], // 其他资质图片
        enterprise_name: '', // 企业名称
        type_of_enterprise: '', // 企业类型
        credit_code: '', // 信用代码
        licensed_legal_person: '', // 执照法人
        domicile: '', // 注册地
        registered_capital: '', // 注册资金
        issueTime:'', // 注册时间
        term_of_operation: '', // 证照期限
        business_scope: '' // 经营范围
      },
      ruleForm_phone: false,
      icon_loading: false,
      options_as: regionData, // 地区
      dialogVisible: false,
      codeId: '', // codeId

      searchQuery: '',  
      searchResults: [], // 假设这里是从后端API获取的搜索结果  
      showDropdown: false,  
      searchTimeout: null, 

      ruleF: {
        phone: [
          {required: true, message: "请输入联系方式", trigger: "blur"},
          {min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur"},
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            //pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号码",
          },
        ]
      },
      rules: {
        name: [
          {required: true, message: '请输入店铺名称', trigger: 'blur'},
        ],
        intro: [
          {required: true, message: '请输入店铺简介', trigger: 'blur'},
        ],
        region: [
          {type: 'array', required: true, message: '请选择店铺所在地区', trigger: 'change'},
        ],
        posAdmin: [
          {required: true, message: '请输入店铺管理员昵称', trigger: 'blur'},
        ],
        shop_contact_number: [
          {required: true, message: "请输入店铺联系方式", trigger: "blur"},
          {min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur"},
          {
            // pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            // pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
          },
        ],
        shop_contact_address: [
          {required: true, message: "请输入店铺联系地址", trigger: "blur"}
        ],
        enterprise_name:[
          { required: true, message: '请选择企业名称', trigger: 'change' }
        ],
        type_of_enterprise:[
          {required: true, message: '请输入企业类型', trigger: 'blur'}
        ],
        credit_code:[
          {required: true, message: '请输入信用代码', trigger: 'blur'}
        ],
        domicile:[
          { required: true, message: '请选择注册省份', trigger: 'change' }
        ],
        licensed_legal_person:[
          {required: true, message: '请输入执照法人', trigger: 'blur'}
        ],
        registered_capital:[
          {required: true, message: '请输入注册资金', trigger: 'blur'}
        ],
        issueTime:[
          {required: true, message: '请选择注册时间', trigger: 'change'}
        ],
        business_scope:[
          {required: true, message: '请输入营业范围', trigger: 'blur'}
        ],
      }
    }
  },
  computed: {
    getTime() {
      return function (time) {
        return getDate(time)
      }
    }
  },
  created(){

  },
  watch:{
     
  },
  methods: {
    async remoteMethod(query) { 
      if (query !== '') {
          this.loading = true;
          // 清除之前的定时器  
          if (this.searchTimeout) {  
            clearTimeout(this.searchTimeout);  
          }  
          // 设置新的定时器  
          this.searchTimeout = setTimeout(async () => {
            this.loading = false
            // 调用远程搜索方法  
            const { data } = await axios.get('/pos/getCompany?keyword=' + `'${query}'`)
            this.qiyeOptions = data.extend.data.map(item => {
              return {value:item.companyName, lable:item.creditCode, ...item}
            })
            // console.log(this.qiyeOptions);
          }, 1200)
        } else {
          this.options = [];
      }
    },  
    // 让选择框失焦时input不会被清空
    selectBlur(e){
      this.form.enterprise_name = e.target.value
      this.$forceUpdate()
    },
    selectQiye(item){
      this.qiyeOptions.forEach(item2 => {
        if(item === item2.companyName){
          this.form.type_of_enterprise = item2.companyType
          this.form.credit_code = item2.creditCode
          this.form.licensed_legal_person = item2.faRen
          this.form.registered_capital = item2.regMoney
          this.form.issueTime = item2.issueTime
        }
      })
    },
    checkPhone(value) {
      this.ruleForm_phone = !!isvalidPhone(value);
      this.phone_state = false
    },
    clickPhone(){
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if(reg.test(this.ruleForm.phone) === false){
        this.$message.error('请检查手机号格式是否正确')
      }
    },
    phone_search() { // 查询手机号是否存在
      console.log(6666666);
      this.icon_loading = true
      this.schedule_active = 0
      // this.form.shop_contact_number = this.ruleForm.phone

      // this.dialog_visible = false
      // this.dialogVisible_bos = false
      if (this.ruleForm.phone !== '') {
        const url = "pos/checkPhoneIsExist?phone=" + this.ruleForm.phone
        axios.get(url).then(res => {
          setTimeout(() => {
            this.icon_loading = false
            if (res.data.code === 200) {
              const rps = res.data.extend.data
              if (rps === false) {
                // this.$message.error('您的手机号已有登录权限，暂不支持入驻店铺，可更换其他手机号申请入驻!')
                this.phone_state = true
                this.submityan('ruleForm')
              } else {
                  // this.phone_state = true
                // if (rps.flag){
                //   // this.schedule_active = rps.state += 2
                // } else {
                this.getPosDetailVOByPhone(this.ruleForm.phone)
                this.shop_phone = true
                this.dialogVisible_bos = false
                this.form.shop_contact_number = this.ruleForm.phone
                // }
              }
            } else if (res.data.code === 100) {
              this.$message.error(res.data.extend.data)
            } else {
              this.$message.error('请检查手机号格式是否正确')
            }
          }, 1500)
        })
      } else {
        this.$message.error('手机号不可为空!')
      }
    },
    // 根据手机号查询数据
    getPosDetailVOByPhone(phone) {
      const that = this
      const url = 'pos/getPosDetailVOByPhone?phone=' + phone
      axios.get(url).then(res => {
        if (res.data.code === 200) {
          let form = that.ruleForm
          const data = res.data.extend.data

          const dats = data.posAddress.split(',')
          let loc = ''
          let options = []
          if (!parseInt(dats[0])) {
            loc = data.posAddress
            dats[0] === dats[1] ? dats[1] = '市辖区' : dats[1]
            if (dats.length > 1) {
              if (TextToCode[dats[0]].code) {
                options = ([TextToCode[dats[0]].code, TextToCode[dats[0]][dats[1]].code, TextToCode[dats[0]][dats[1]][dats[2]].code])
              } else {
                options = ([CodeToText[dats[0]], CodeToText[dats[0]][dats[1]], CodeToText[dats[0]][dats[1]][dats[2]]])
              }
            } else {
              options = []
            }
          } else {
            const address = data.posAddress.split(',')
            options = address
            address.forEach(item => {
              loc += CodeToText[item] + ','
            })
          }

          let img1 = ''
          let img2 = ''
          data.imgTypeList.map(item => {
            if (item.imgType === 0) {
              img1 = item.imgUrl
            } else if (item.imgType === 1) {
              img2 = item.imgUrl
            } else {
              console.log('图片赋值失败')
            }
          })
          that.form = {
            dialogImageUrl: data.posImg,
            name: data.posName,
            intro: data.posDesc,
            options: loc,
            region: options,

            backup: data.remakeName,
            type: data.takeincolonel,
            profit: data.colonelscale,
            noProfit: data.colonelbscale,
            posAdmin: data.posAdmin,
            shop_contact_number: data.telPhone,
            shop_contact_address: data.contactAddress,
            license: [],
            license2: [],
            dialogImageUrl2: img1,
            dialogImageUrl3: img2,

            enterprise_name: data.companyName, // 企业名称
            type_of_enterprise: data.companyType, // 企业类型
            credit_code: data.creditCode, // 信用代码
            licensed_legal_person: data.faRen, // 执照法人
            registered_capital: data.regMoney, // 注册资本
            issueTime: data.issueTime, // 注册时间
            term_of_operation: data.certificateIndate, // 营业期限
            business_scope: data.certificateRange, // 经营范围
            domicile: data.address // 注册地
          }
          
          that.form.logoImg = []
          that.form.logoImg.push({url: data.posImg})
          that.form.license.push({url: img1})
          if(img2){
            that.form.license2.push({url: img2})
          }
          
          that.floot_bottom = '更新'
          // console.log(data,that.form.license2,'数据555');
          that.posid = data.posId
          that.dialogVisible_bos = false
        }
      })
    },
    submitForm() { // 查询店铺
      const that = this
      if (that.ruleForm.yanzhengma !== '') {
        const url = 'pos/getPosEntityByPhone'
        const data = {
          code: that.ruleForm.yanzhengma,
          phone: that.ruleForm.phone
        }
        axios.post(url, data).then(res => {
          if (res.data.code === 200) {
            this.shop_phone = true
            this.dialogVisible_bos = false
            this.form.shop_contact_number = this.ruleForm.phone
          } else {
            // this.$message.error('您的手机号已有登录权限，暂不支持入驻店铺，可更换其他手机号申请入驻!')
            this.$message.error(res.data.extend.data)
          }
        })
      } else {
        that.$message.error('验证码不可为空!')
      }
    },
    // 发送验证码
    submityan(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          const TIME_COUNT = 60
          if (!this.timer) {
            this.count = TIME_COUNT
            this.countshow = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.countshow = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
          const url1 = 'login/sendSms?phone=' + this.ruleForm.phone
          axios.get(url1).then(res => {
            if (res.data.code === 200) {
              const data = res.data.extend
              this.codeId = data.phoneCodeId
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    store_address() {
      this.$refs.form.validateField('region')
    },
    // 店铺logo图片上传事件
    beforeAvatarUpload(file){
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      console.log(file.type,isJPG)
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式或者 PNG 格式')
      }
      return isJPG
    },
    uploadseccess(response, file, fileList) {
      // if (this.form.dialogImageUrl === '') {
      //   this.file = file.raw
      //   const formData = new FormData()
      //   formData.append('file', this.file)
      //   axios.post('fileUpload/uploadImg', formData, {
      //     headers: {
      //       'Content-type': 'multipart/form-data'
      //     }
      //   }).then((response) => {
          if (response.code === 200) {
            this.form.dialogImageUrl = response.extend.resultMap.url // 店铺logo
            this.form.logoImg.push(response.extend.resultMap) // 店铺logo
            this.uploadSwitch1 = this.form.dialogImageUrl !== ''
            this.$message({
              message: '上传图片成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '上传图片失败',
              type: 'error'
            })
            // this.handleRemove()
          }
      //   }).catch((response) => {
      //     console.log('错误' + response)
      //   })
      // } else {
      //   console.log('123')
      // }
    },
    // 删除店铺logo图片事件
    handleRemove() {
      this.form.dialogImageUrl = ''
      this.form.logoImg = []
      this.uploadSwitch1 = false
      // this.$message({
      //   message: '图片删除成功',
      //   type: 'success'
      // })
    },
    // 店铺证照图片上传事件
    uploadseccess2(response, file, fileList) {
      // if (this.form.dialogImageUrl2 === '') {
      //   this.file = file.raw
      //   const formData = new FormData()
      //   formData.append('file', this.file) 
      //   axios.post('fileUpload/uploadImg', formData, {
      //     headers: {
      //       'Content-type': 'multipart/form-data'
      //     }
      //   }).then((response) => {
          if (response.code === 200) {
            this.form.dialogImageUrl2 = response.extend.resultMap.url // 商品主图
            this.form.license.push(response.extend.resultMap) // 商品主图
            this.uploadSwitch2 = this.form.dialogImageUrl2 !== ''
            this.$message({
              message: '上传图片成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '上传图片失败',
              type: 'error'
            })
            // this.handleRemove2()
          }
      //   }).catch((response) => {
      //     console.log('错误' + response)
      //   })
      // } else {
      //   console.log('123')
      // }
    },
    // 删除店铺证照图片事件
    handleRemove2() {
      this.form.dialogImageUrl2 = ''
      this.form.license = []
      this.uploadSwitch2 = false
      // this.$message({
      //   message: '图片删除成功',
      //   type: 'success'
      // })
    },
    // 其他资质图片上传事件
    uploadseccess3(response, file, fileList) {
      // if (this.form.dialogImageUrl3 === '') {
      //   this.file = file.raw
      //   const formData = new FormData()
      //   formData.append('file', this.file)
      //   axios.post('fileUpload/uploadImg', formData, {
      //     headers: {
      //       'Content-type': 'multipart/form-data'
      //     }
      //   }).then((response) => {
          if (response.code === 200) {
            this.form.dialogImageUrl3 = response.extend.resultMap.url // 商品主图
            this.form.license2.push(response.extend.resultMap) // 商品主图
            this.uploadSwitch3 = this.form.uploadSwitch3 !== ''
            this.$message({
              message: '上传图片成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '上传图片失败',
              type: 'error'
            })
            // this.handleRemove3()
          }
      //   }).catch((response) => {
      //     console.log('错误' + response)
      //   })
      // } else {
      //   console.log('123')
      // }
    },
    // 删除其他资质图片事件
    handleRemove3() {
      this.form.dialogImageUrl3 = ''
      this.form.license2 = []
      this.uploadSwitch3 = false
      // this.$message({
      //   message: '图片删除成功',
      //   type: 'success'
      // })
    },
    // 根据省市区选择器得到最终的地址信息
    handleChange() {
      let loc = ''
      for (let i = 0; i < this.form.region.length; i++) {
        loc += CodeToText[this.form.region[i]] + ','
      }
      this.form.options = loc.slice(0, loc.length - 1)
    },
    // 提交事件
    onSubmit(forName) {
      // console.log(this.options_as);
      const that = this
      that.$refs[forName].validate((valid) => {
        if (valid) {
          const active = that.form
          // const url = this.floot_bottom === '提交' ? 'pos/addNewPos' : '/back/pos/updatePos'
          const url = 'pos/addNewPos'
          const PosAddDto = {
            posImg: active.dialogImageUrl, // logo
            posName: active.name, //店铺名称
            posDesc: active.intro, // 简介
            posAddress: active.options, // 所在地区
            remakeName: active.backup, // 备注
            posAdmin: active.posAdmin, // 店铺管理员昵称
            telPhone: active.shop_contact_number, // 店铺联系电话
            contactAddress: active.shop_contact_address, // 店铺联系地址
            imgTypeList:[]
          }
          const posCertificate = {
            contactAddress: active.shop_contact_address, // 店铺联系地址
            companyName: active.enterprise_name, // 企业名称
            companyType: active.type_of_enterprise, // 企业类型
            creditCode: active.credit_code, // 信用代码
            faRen: active.licensed_legal_person, // 执照法人
            regMoney: active.registered_capital, // 注册资本
            issueTime: active.issueTime, // 注册时间
            certificateIndate: active.term_of_operation, // 营业期限
            certificateRange: active.business_scope, // 经营范围
            provinceId: active.domicile // 注册地
          }
          if (this.floot_bottom === '更新') {
            PosAddDto.posId = this.posid
            posCertificate.certificateid = this.certificateid
            that.success = '更新成功'
          }
          // const ImgType = []
          if (this.form.dialogImageUrl2 !== '') {
            PosAddDto.imgTypeList.push({imgUrl: this.form.dialogImageUrl2, imgType: 0})
          }
          if (this.form.dialogImageUrl3 !== '') {
            PosAddDto.imgTypeList.push({imgUrl: this.form.dialogImageUrl3, imgType: 1})
          }
          console.log(active);
          if (active.logoImg.length === 0 && active.dialogImageUrl === '') {
            that.$message({
              message: '店铺LOGO必须上传',
              type: 'error'
            });
          } else if (active.license.length === 0 && active.dialogImageUrl2 === '') {
            that.$message({
              message: '执照照片必须上传',
              type: 'error'
            });
          } else {
            // that.$axios.post(url, JSON.stringify({PosAddDto, ImgType})).then(res => {
            // console.log({...PosAddDto,...posCertificate},'提交');
            that.$axios.post(url, {...PosAddDto,...posCertificate}).then(res => {
              if (res.data.code === 200) {
                this.$message.success('店铺入驻信息已提交，请等待审核')
                that.dialogVisible = true
                // 提交成功后用于刷新当前页面
                setTimeout(() => {
                  this.dialogVisible_bos = true
                },2000)
                
              } else if (res.data.code === 100 || res.data.extend.data.code !== 0) {
                // that.$message.error(res.data.extend.data.code === 2 ? '添加失败，当前商户审核失败' : '添加失败，手机号已被注册')
                that.$message.error(res.data.extend.data)
              } else {
                that.$message.error('操作失败')
              }
            }).catch(error => {
              console.log(error);
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })

    },
    handleClose(formName) {
      const that = this
      that.$refs[formName].resetFields()
      that.dialogVisible = false
      that.form.logoImg = []
      that.form.license = []
      that.shop_phone = false
    },
    fenzuResetForm() {
      this.handleClose('form')
    },
    // 监听 非团购商品利润 输入框
    checkNumber() {
      // 只允许输入数字
      this.form.profit = this.form.profit.replace(/[^\d]/g, '')
      // 最小值为1
      if (this.form.profit < 1) {
        this.form.profit = 1
      } else if (this.form.profit > 99) {
        this.form.profit = 99
      } else {
        // console.log('错误:' + this.form.noProfit)
      }
    },
    // 监听 团购商品利润 输入框
    checkNumberB() {
      // 只允许输入数字
      this.form.noProfit = this.form.noProfit.replace(/[^\d]/g, '')
      // 最小值为1
      if (this.form.noProfit < 1) {
        this.form.noProfit = 1
      } else if (this.form.noProfit > 99) {
        this.form.noProfit = 99
      } else {
        // console.log('错误:' + this.activeUser.colonelscale)
      }
    },
    // handleInput() {  
    //   // 当用户输入时，重置定时器  
    // },  
    // selectItem(item) {  
    //   // 点击下拉框项时，更新搜索框的值并隐藏下拉框  
    //   this.searchQuery = item;  
    //   this.showDropdown = false;  
    //   // 清除定时器  
    //   if (this.searchTimeout) {  
    //     clearTimeout(this.searchTimeout);  
    //     this.searchTimeout = null;  
    //   }  
    // },
  }
}
</script>

<style lang="less" scoped>
li {
  list-style: none;
}

.app {
  margin: 0 auto;
  width: 80vw;

  .logo {
    height: 100px;

    .but {
      width: 100%;

      .logo_img {
        width: 50px;
        height: 100%;
        vertical-align: middle;
      }

      .logoText {
        display: inline-block;
        color: #333;
        font-size: 20px;
        font-weight: bold;
        margin-left: 6px;
      }
    }
  }

  /*表单*/

  .body {
    width: 100%;
    height: auto;
    background-color: #fff;
    opacity: 1;
    border: 2px solid #EBEBEB;
    margin-bottom: 100px;

    .header {
      box-sizing: border-box;
      width: 100%;
      height: 50px;
      background: #F4F4F4;
      border-radius: 0 0 0 0;
      opacity: 1;
      border-bottom: 2px solid #EBEBEB;

      .text {
        font-size: 20px;
        margin: 0;
        line-height: 50px;
        text-align: center;
      }
    }

    .main {
      margin: 45px 90px 20px;
      // 审核进度
      .schedule {
        margin-bottom: 15px;

        .account {
          margin-top: 5px;
          font-size: 16px;
        }

        /deep/ .el-divider {
          background-color: #F3F3F3;
        }
      }

      .shop {
        font-size: 16px;
        font-weight: 900;
        border-left: 4px solid #2082dd;
        padding-left: 6px;
      }

      .shop1 {
        margin: 10px 0 20px 0;
      }

      .form {
        padding: 20px 0;

        /deep/ .el-form-item__label {
          font-weight: 700;
        }

        /deep/ .el-divider--horizontal {
          background-color: #F3F3F3;
        }

        .logo_text {
          padding-left: 8px;
          font-size: 12px;
          color: #787878;
        }

        .el-input, .el-textarea, .el-select {
          width: 60%;
        }

        .form_backup {
          /deep/ .el-form-item__label {
            padding-left: 11px;
          }
        }
        .uploadSeccess {
          /deep/ .el-form-item__label::before {
            content: '* ';
            color: red;
          }
        }

        /deep/ .el-textarea__inner, /deep/ .el-input__inner {
          font-size: 13px;
          color: #000;
          font-weight: 900;
        }

        .el_image {
          height: 80px;
          display: inline-block;
          vertical-align: middle;
          padding: 0;

          .el_image_li {
            position: relative;
            margin-right: 10px;

            .icon_error {
              position: absolute;
              top: -8px;
              right: -5px;
              font-size: 20px;
            }
          }
        }

        .form_name {
          .form_name_text {
            font-size: 16px;
            margin: 0 5px 0 10px;
          }

          .form_name_img {
            width: 16px;
            height: 16px;
          }

          .for_img {
            margin-left: 10px;
          }
        }

        .form_logo {
          .logo_img {
            width: 75px;
            height: 56px;
            vertical-align: middle;
          }

          .uploadLogo {
            /deep/ .el-upload {
              //display: none;
              background: none;
              border: 0;
            }
          }
          .uploadLogoClass {
            /deep/ .el-upload {
              display: none;
            }
          }
        }

        .store_logo {
          //.store_name,
          //.form_intro,
          //.form_area
          //.store_information,
          //.store_address
          /deep/ .el-form-item__label::before {
            content: '* ';
            color: red;
          }

          /deep/ .el-form-item__content {
            display: flex;
            position: relative;
          }
        }

        .button_item {
          width: 100%;
          margin-top: 30px;
          text-align: center;

          .create_button {
            width: 240px;
            height: 46px;
            background: #2082dd;
            opacity: 1;

            /deep/ span {
              font-size: 16px;
              font-weight: 700;
            }

            .font_text_bbss {
              color: red;
              //font-size: 16px;
              font-size: 1.5em;
            }
          }

          .el-button--primary {
            border-color: #2082dd;
          }
        }

        .profit {
          .reference {
            border: none;
            background: none;
            padding: 0;
          }

          .reference2 {
            padding-left: 5px;
          }
        }

        .form_area {
          /deep/ .el-form-item__content {
            .formItemCascader {
              width: 60%;
            }
          }
        }
      }

      .dialog_prompt {
        /deep/ .el-dialog--center {
          padding: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          .el-dialog__header {
            padding: 0;
          }

          .el-dialog__body {
            padding: 0;
            text-align: center;
          }
        }
      }

      .dialogVisible_bos {
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/ .el-dialog--center {
          //box-shadow: none;
          //-webkit-box-shadow: none;
          margin-top: 0 !important;
          border-radius: 10px;
          box-shadow: 0.3px 1.3px 2.6px #D8EAE5, 2px 3px 21px #D8EAE5;

          .el-dialog__header {
            display: none;
            //border-bottom: 1px solid #cccccc;
            //
            //.el-dialog__title {
            //  font-weight: 900;
            //  color: #000;
            //}
          }

          .el-dialog__body {
            padding-bottom: 0;

            .login-form {
              box-sizing: border-box;

              .wrap {
                text-align: center;
                padding: 1vw;
                .img_but {
                  .logo_img {
                    width: 60px;
                  }
                }
                .title_but {
                  display: inline-block;
                  font-size: 22px;
                  font-weight: 900;
                  margin-top: 10px;
                  margin-bottom: 36px;
                  color: #494949;
                }

                .el-form-item__label {
                  font-weight: 700;
                }

                .phone {
                  position: relative;
                  margin-bottom: 0;

                  .input-with-select {
                    .el-input__inner {
                      border-radius: 12px;
                    }
                    .el-input-group__append {
                      background-color: #fbfbfb;

                      .iconfont {
                        font-weight: 900;
                        font-size: 24px;
                      }
                    }
                  }
                  .iconfont,.ips {
                    position: absolute;
                    right: 10px;
                    top: 0;
                    color: #929292;
                    //background-color: orange;
                    font-weight: 900;
                    font-size: 25px;
                  }
                  .ips {
                    top: 7px;
                    color: #000;
                  }
                }

                .yanzhengma {
                  margin-top: 12px;
                  margin-bottom: 0;
                  .el-form-item__content {
                    .el-input {
                      .el-input__inner {
                        border-top-left-radius: 12px;
                        border-bottom-left-radius: 12px;
                      }
                      .el-input-group__append {
                        border-top-right-radius: 12px;
                        border-bottom-right-radius: 12px;
                      }
                    }
                  }

                  .el-form-item__label:before {
                    content: '*';
                    color: #f36e70;
                    margin-right: 4px;
                  }

                  .but_2 {
                    margin: 0;

                    span {
                      color: #000;
                    }
                  }

                  .but_2:hover {
                    border-left: none;
                    background-color: #f5f7fa;
                  }
                }
              }
            }
          }

          .el-dialog__footer {
            .dialog-footer {
              width: 100%;
              display: flex;
              justify-content: space-around;
              .el-button--primary {
                font-size: 13px;
                background-color: #2082dd;
                border-color: #2082dd;
                width: calc(100% - 40px);
                border-radius: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.dialogVisible_state_log {
  animation: anim-open 3s ease;
}

.dialogVisible_out_log {
  animation: anim-close 3s ease;
}

@keyframes anim-open {
  0% {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes anim-close {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
}

.dropdown {  
  /* 样式代码，如位置、宽度、背景等 */  
  position: absolute;  
  background-color: #fff;  
  border: 1px solid #ccc;  
  margin-top: 2px;  
  max-width: 200px;  
  z-index: 10;  
}  
</style>



// WEBPACK FOOTER //
// src/components/PC.vue